import { lazyWithErrorHandle } from "@/utils/utils";
import type { RouterProps } from "../../../router/index";
import OverseasSalesSpeed from "../routerInfo/OverseasSalesSpeed";
import Jurisdiction from "../routerInfo/jurisdiction";
import Overseas from "../routerInfo/overseas";
import DevelopMeeting from "../routerInfo/developMeeting";
import OversearMenu from "../routerInfo/oversearMenu";

const UserLoginLaterLayout: RouterProps[] = [
  // StoreAmmeter,
  Overseas,
  OverseasSalesSpeed,
  DevelopMeeting,
  OversearMenu,
  Jurisdiction,
  {
    path: "/operationManual",
    component: lazyWithErrorHandle(() => import("@/pages/OperationManual")),
  },
  // {
  //   path: "/maintenanceSettings",
  //   component: lazyWithErrorHandle(() => import("@/pages/MaintenanceSettings")),
  // },
];

export default UserLoginLaterLayout;
